module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAlCAMAAAADS4u8AAAAPFBMVEUAAABFRUVERERGRkZHR0dERERERERERERERERGRkZERERERERERERERERMTExERERERERGRkZFRUVERERxkYSeAAAAE3RSTlMAteYmG9udk4o+9c2AcRDvqDJP6vqDuQAAAKFJREFUOMvd0MEOgjAQhOEpIBQFBeb931U2NIwxdtsj8T9/h53Fj55xg5vkg5yrpWxB3reFnOok0Mt6cgQqbHfIZKMnbyZTg6wjZfPydUjZwZcqyn7LFUrWlWoie1iqlSzYtiF36VpJIhPJ5VM2HjUr2Xp03q0kPAqzp/Sp2QD0JkUDz4Ko2RHr0KFMsUWkCgdY16OZWSV69Vl/9oGQpwFHb8DaE0YVOrQ/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/home@2x.png
// module id = 1056
// module chunks = 85